import React, {useState, useEffect} from 'react';
import * as R from 'ramda';
import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';
import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import SearchBox from '@/b2b/pages/Commissions/SearchBox';
import StatementList from '@/b2b/pages/Commissions/StatementList';

import {blank} from '@/util';
import api from '@/api';

const Commissions = () => {
  const [producer] = useProducerCtx();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const {t: tr} = useTranslation();

  useEffect(
    () => {
      const fetchData = () => {
        setLoading(true);
        api
          .get(`/b2b/commissions/list_statement/${producer.producerId}`)
          .then(({data}) => {
            const errors = R.propOr({}, 'errors')(data);
            if (blank(errors)) {
              setItems(data);
            }
            setLoading(false);
          });
      };

      fetchData();
    },
    [producer]
  );

  return (
    <>
      <SearchBox producerName={producer.producerFullName} />
      <LoadingOverlay active={loading} spinner text={tr('loading')}>
        <StatementList items={items} />
      </LoadingOverlay>
    </>
  );
};

export default Commissions;
